import { useAuth } from '../contexts/AuthContext';

const OUTCOME = {
  succeeded: 'The server confirmed your last action. Check the current state before acting again.',
  refused: 'The server refused your last action. Check the current state before acting again.',
  unknown: 'The outcome of your last action was not confirmed by the server. Check the current state before trying again.',
};

/**
 * Session notices that must survive a screen change (#583 S5, fix round 1). Every message is a
 * fixed string with no operator or family data, so it may show in any session state.
 */
export default function ConsoleNotices() {
  const {
    logoutUnconfirmed, logoutRetryable, retryLogout, dismissLogoutRetry,
    loginInterrupted, dismissLoginInterrupted,
    mutationOutcome, dismissMutationOutcome,
  } = useAuth();

  if (!logoutUnconfirmed && !loginInterrupted && !mutationOutcome) return null;

  return (
    <div className="console-notices">
      {mutationOutcome && (
        <div className="console-notice" role="alert">
          <p>{OUTCOME[mutationOutcome]}</p>
          <button type="button" className="btn btn-outline" onClick={() => dismissMutationOutcome()}>Dismiss</button>
        </div>
      )}
      {loginInterrupted && (
        <div className="console-notice" role="alert">
          <p>Sign-in was interrupted — please try again.</p>
          <button type="button" className="btn btn-outline" onClick={() => dismissLoginInterrupted()}>Dismiss</button>
        </div>
      )}
      {logoutUnconfirmed && (
        <div className="console-notice" role="alert">
          <p>Sign-out was not confirmed by the server</p>
          <div className="session-gate-actions">
            {logoutRetryable && (
              <button type="button" className="btn btn-outline" onClick={() => retryLogout()}>Retry sign-out</button>
            )}
            <button type="button" className="btn btn-outline" onClick={() => dismissLogoutRetry()}>Dismiss</button>
          </div>
        </div>
      )}
    </div>
  );
}
